import { ControlIcons } from 'owa-control-icons';
import { default as Delete } from 'owa-fluent-icons-svg/lib/icons/DeleteRegular';
import { default as Archive } from 'owa-fluent-icons-svg/lib/icons/ArchiveRegular';
import { isFeatureEnabled } from 'owa-feature-flags';

export function getBigHoverActionIcon(action: string) {
    const hasDensityNext = isFeatureEnabled('mon-densities');

    switch (action) {
        case 'Delete':
            return hasDensityNext ? Delete : ControlIcons.Delete;
        case 'Archive':
            return hasDensityNext ? Archive : ControlIcons.Archive;
    }

    return null;
}
